<template>
  <div>
    <div class="p-2" v-if="dailyAgendas.length > 0">
      <ul class="flex flex-wrap gap-1" id="agendaTab" role="tablist">
        <li v-for="(daily, index) in dailyAgendas" :key="index">
          <button
            class="p-2 pb-1 rounded-t-lg hover:bg-default-200 bg-default-100"
            data-toggle="tab"
            role="tab"
            :class="{ 'bg-default-200': dailyDate === daily.date }"
            :id="'date-' + daily.date + '-tab'"
            @click="changeDate(daily.date)"
            :href="'#date-' + daily.date"
            :aria-controls="'date-' + daily.date"
            :aria-selected="currentDate === daily.date ? 'true' : 'false'"
          >
            <div class="day-agenda">
              <h6 class="mb-0">{{ daily.day }}</h6>
              <div class="description-agenda">
                <small>{{ daily.day_week }}</small> <br />
                <small>{{ daily.month }} de {{ daily.year }}</small>
              </div>
            </div>
          </button>
        </li>
      </ul>

      <div class="rounded-b-lg shadow bg-default-200" id="agendaTabContent">
        <div
          v-for="(daily, index) in dailyAgendas"
          :key="index"
          :class="{ 'active': currentDate === daily.date }"
          :id="'date-' + daily.date"
          role="tabpanel"
          :aria-labelledby="'date-' + daily.date + '-tab'"
        >
          <ul v-show="dailyDate == daily.date" class="grid grid-cols-1 divide-y divide-white">
            <li v-for="(agenda, i) in daily.data" :key="i">
              <a
                class="block p-2 hover:bg-default-300"
                :href="agenda.links.url"
              >
                <h6 class="text-xs">
                  {{ agenda.title }}
                </h6>
                <small class="description-agenda">
                  <div><strong>Localização: </strong> {{ agenda.place }}</div>
                  <div class="">
                    <span> <strong>Período:</strong> {{ agenda.period }} </span>
                    &bull;
                    <span>
                      <strong>Horario:</strong> {{ agenda.time_start }}
                    </span>
                  </div>
                </small>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="rounded-lg p-2 mx-4 mb-4 bg-yellow-100 text-yellow-900">
      Esta semana não possui pautas cadastradas
    </div>
  </div>
</template>

<script>
import Semed from "../api/Semed";

export default {
  data() {
    return {
      dailyAgendas: {},
      dailyDate: `${new Date().getFullYear()}-${String(
        new Date().getMonth() + 1
      ).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`,
      currentDate: `${new Date().getFullYear()}-${String(
        new Date().getMonth() + 1
      ).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`,
    };
  },
  created() {
    this.getAgendas("institutional/agendas/highlights/educacao");
  },
  methods: {
    changeDate(dailyDate) {
      this.dailyDate = dailyDate;
    },
    getAgendas(link) {
      this.loading = true;
      Semed.get(link).then((response) => {
        this.dailyAgendas = response.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.day-agenda {
  line-height: 0.7rem;
}
.description-agenda {
  font-size: 0.8rem;
}
.agenda-links h6 {
  font-size: 0.8rem;
  font-weight: bold;
}
</style>
